import { useAppUser } from "modules/auth/user/hooks/useAppUser";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

export function useIsUserPage() {
  const { appUser, isPending: isPendingUser } = useAppUser();
  const pathname = usePathname();

  return useMemo(
    () =>
      Boolean(
        !isPendingUser &&
          appUser?.username &&
          pathname?.includes(`/users/${appUser.username}`)
      ),
    [isPendingUser, appUser?.username, pathname]
  );
}
